import React from "react";
import { formatDisplayNumber } from "../../../../../../../utility/utils";

const MAX_VISIBLE = 2;

const spanStyle = {
    backgroundColor: "#04864A",
    borderRadius: "1rem",
    fontWeight: 600,
    color: "#fff",
    fontSize: "0.75rem",
};

const formatOrigenLabel = (pallet) => {
    if (pallet.es_sobrante) return "Sobrante";
    if (pallet.pallet_numero) return pallet.pallet_numero;
    return "N/A";
};

// para el sobrante se agrega el desglose por producto (en kg) en el title
const formatItemTitle = (item) => {
    const base = `${formatOrigenLabel(item)} (${formatDisplayNumber(item.pacas_consumidas)})`;

    if (item.es_sobrante && item.detalles && item.detalles.length > 0) {
        const detalle = item.detalles
            .map(
                (d) =>
                    `${d.producto_nombre} (${formatDisplayNumber(d.kg_secos)} kg)`,
            )
            .join(", ");

        return `${base}: ${detalle}`;
    }

    return base;
};

// construye los items a mostrar (pallets + sobrante) a partir de un pallet
// serializado por el backend
export const construirItemsReclasificacion = (pallet) => {
    const items = [...(pallet.consumo_reclasificacion || [])];

    const detallesSobrante = pallet.consumo_sobrante || [];

    if (detallesSobrante.length > 0) {
        items.push({
            es_sobrante: true,
            pacas_consumidas: pallet.total_pacas_sobrante || 0,
            detalles: detallesSobrante,
        });
    }

    return items;
};

export const PalletsReclasificacion = ({ pallets, align="center" }) => {
    if (!pallets || !Array.isArray(pallets)) {
        return <span>—</span>;
    }

    if (pallets.length <= 0) {
        return <span>—</span>;
    }

    const allPalletsTitle =
        pallets.length > 0
            ? pallets.map((p) => formatItemTitle(p)).join(", \n")
            : "No hay pallets en reclasificación";

    const visiblePallets = pallets.slice(0, MAX_VISIBLE);
    const hiddenCount = pallets.length - MAX_VISIBLE;

    return (
        <div
            className={`d-flex gap-10 justify-content-${align} align-items-center`}
            title={allPalletsTitle}
        >
            {visiblePallets.map((pallet, index) => (
                <span
                    key={pallet.id || index}
                    className="text-nowrap px-2 py-1"
                    style={spanStyle}
                    title={formatItemTitle(pallet)}
                >
                    {formatOrigenLabel(pallet)} ({formatDisplayNumber(pallet.pacas_consumidas)})
                </span>
            ))}

            {hiddenCount > 0 && (
                <span className="text-nowrap px-2 py-1" style={spanStyle}>
                    +{hiddenCount}
                </span>
            )}
        </div>
    );
};
